import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill-mention';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

const domain = window.location.hostname;
export default {
  components: {
    Multiselect,
  },
    data() {
      return ({
        token_exists: false,
        user_details: {
          "user_role": '',
          "user_id": '',
          "first_name": '',
          "last_name": '',
        },
        temporaryPost: null,
        temporary_hub_post:null,
        isSubmitting: false,
        isDropdownVisible: false,
        fileName:'',
        imagePreview: null,
        topics:[],
        created_by_id:this.created_by,
        portals:[],
        isMaster: false,
        selectedPortals: [],
        selectedMasterPortal: '',
        selectedPortalId: null,
        selectedTopicId: null,
        selectedVisibility: 'public',
        searchQuery:"",
        errors: {
          audio_file :null,
          portal: null,
          segment: null,
          report_description: null
        },
        users:[],
        selectedUserIds: [],
        portal_users:[],
        isRecording: false,
        audio_file: null,
        mediaRecorder: null,
        recordedChunks: [],
        audio_file_name: '',
        upload_media: null,
        fileError : '',
        audioError: '',
        comments_off: true,
        showSuggestions: false,
        currentTagPosition: -1,
        portal_types:[],
        selectedPortalType:null,
        payload:{},
        cbo_domain: false,
        members: [],
       grouped_tags: {},      // Use object if you're looping via (tags, category)
       selected_tags: new Map(),
       selected_categories: []  // This should also be an object keyed by category name

      });
    },
    props: {
      group_id: {
        type: String,
        required: false,
        default: null
      },
      created_by: {
        type: String,
        required: false,
        default: null
      },
      is_public: {
        type: Boolean,
        default: false,
      }
    },

    mounted() {
      this.token_exists = get_token();
      this.user_details=get_user_details();
      this.fetch_grouped_tags();
      this.fecthPortalTypes();
      this.fetch_users();
      this.$nextTick(() => {
        this.initQuillEditor();
      });
      if(this.$route.name === 'view_portal'){
        this.selectedPortalId = this.$route.params.portal_id
        this.fecthTopics(this.selectedPortalId);
      }
      if(this.$route.name === 'view_incidents'){
        this.payload={
          filter_values: {
            portal_type__name:'incident'
          }
        }
      }
      else{
        this.payload={}
      }
      this.fetchPortals();

     const feedModal = $('#feed_modal');
      feedModal.on('show.bs.modal', () => {
        this.resetPortalSelection();
        const quill = this.$refs.quillReportEditorRef?.quill;
        if (quill) {
          quill.setText('');
        }

          this.currentTagPosition = null;
          this.searchQuery = '';
          this.showSuggestions = false;
      });

      if (domain.includes('cbo')) {
          this.cbo_domain = true;
        }
    },
    watch: {
      '$route.params.portal_id'() {
        this.fetch_users();
        this.fecthTopics(this.$route.params.portal_id);
      }
    },

    computed: {
      portal_id() {
        return this.$route.params.portal_id;
      },
      isPublic() {
        return this.selectedVisibility === 'public';
      },
      isViewPortalPage() {
        return this.$route.name === 'view_portal';
      },
      filteredUsers() {
        if (!this.searchQuery) {
          return this.members;
        }
        const query = this.searchQuery.toLowerCase();
        return this.users.filter(user =>
          user.first_name.toLowerCase().includes(query) ||
          user.last_name.toLowerCase().includes(query)
        );
      },
      areAllSelected() {
        const filteredIds = this.filteredUsers.map(user => user.id);
        return filteredIds.every(id => this.selectedUserIds.includes(id)) && filteredIds.length > 0;
      },
      filteredPortals() {
        if (!this.searchQuery) {
            return this.portals.filter(portal =>
                !portal.portal_type || portal.portal_type.name !== 'incident'
            );
        }
        const query = this.searchQuery.toLowerCase();
        return this.portals.filter(portal =>
            (!portal.portal_type || portal.portal_type.name !== 'incident') &&
            portal.name.toLowerCase().includes(query)
        );
    },
    areAllSubPortalsSelected() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);
      return filteredIds.length > 0 && filteredIds.every(id => this.selectedPortals.includes(id));
  },
    },

    methods: {

      resetPortalSelection() {
        this.selectedPortalId = '';
        this.selectedTopicId = '';
        this.errors.portal = '';
        this.errors.segment = '';
        this.errors.name = '';
        this.fileName = '';
        this.upload_media = null;
        this.imagePreview = null;
        this.uploaded_files = [];
        this. audio_file_name = '';
        this.fileError = '';
        this.report_description = '';
        this.description = '';
      },
      toggleDropdown() {
        this.isDropdownVisible = !this.isDropdownVisible;
      },
      handleCustomer(){
        const role =this.user_details.user_role
        if(role === 'user'){
          return false
      }
      else {
        return true
      }
    },
    fetch_portal_members() {
          this.members = [];

          if(!this.portal_id) return;

          this.isLoading = true;
          $.ajax({
              url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
              method: "GET",
              data: { portal_id: this.portal_id },
              headers: {
                "Authorization": `Token ${this.getToken()}`,
                "Content-Type": "application/json"
              },
              success: (response) => {
                if (response.status === "success") {
                  this.members = response.data.members;
                       setTimeout(() => {
              this.loading = false;
          }, 1000);
                    }
                  },
                  error: (xhr) => {
                    console.error("Error fetching portal members:", xhr);
                  },
                  complete: () => {
                  this.isLoading = false;
                }
          });
        },
      
    toggleSelectAll() {
      const filteredIds = this.filteredUsers.map(user => user.id);
      if (this.areAllSelected) {

        this.selectedUserIds = this.selectedUserIds.filter(id => !filteredIds.includes(id));
      } else {
        this.selectedUserIds = [...new Set([...this.selectedUserIds, ...filteredIds])];
      }
    },
    toggleSelectAllSubPortals() {
      const filteredIds = (this.filteredPortals || []).map(portal => portal.id);

      if (this.areAllSubPortalsSelected) {
          this.selectedPortals = this.selectedPortals.filter(id => !filteredIds.includes(id));
      } else {
          this.selectedPortals = [...new Set([...this.selectedPortals, ...filteredIds])];
      }
  },

  fetch_grouped_tags() {
  this.isLoading = true;

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
    method: 'GET',
    headers: {
      'Authorization': `Token ${this.getToken()}`,
      'Content-Type': 'application/json'
    },
    success: (response) => {
      if (response.status === "success") {
        const tag_list = response.data.tags;

        // ✅ Use Map to group tags by category name
        const grouped = new Map();

        tag_list.forEach(tag => {
          const categoryName = tag.tag_category.name;

          if (!grouped.has(categoryName)) {
            grouped.set(categoryName, []);
          }

          grouped.get(categoryName).unshift({
            id: tag.id,
            name: tag.name
          });
        });

        // ✅ Convert grouped Map to an array and store as grouped_tags
        this.grouped_tags = Array.from(grouped.entries()).map(([name, tags]) => ({
          id: Date.now() + Math.random(), // Temporary unique ID
          name,
          tags
        }));

        // ✅ Initialize selected_tags as a Map
        this.selected_tags = new Map();

        this.grouped_tags.forEach(cat => {
          this.selected_tags.set(cat.name, null);
        });
      }
    },
    complete: () => {
      this.isLoading = false;
    }
  });
},
 submit_tags() {
  this.selected_categories = [];

  Object.entries(this.selected_tags).forEach(([categoryName, tagId]) => {
    if (tagId) {
      const category = this.grouped_tags.find(cat => cat.name === categoryName);
      if (category) {
        const tag = category.tags.find(t => t.id === tagId);
        if (tag) {
          this.selected_categories.push({ id: tag.id, name: tag.name });
        }
      }
    }
  });
}
,

    fecthPortalTypes() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_types`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.portal_types=response.portal_types
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.fileError = "Audio files are not allowed.";
          this.upload_media = null;
          this.fileName = "";
          this.imagePreview = null; // Reset preview if an invalid file is selected
          event.target.value = ""; // Clear file input
        } else {
          this.fileName = file.name;
          this.fileError = "";
          this.upload_media = file;

          // Check if the file is an image before previewing
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.imagePreview = null; // Reset preview for non-image files
          }
        }
      } else {
        this.fileName = "";
        this.fileError = "";
        this.upload_media = null;
        this.imagePreview = null;
      }
    },
    onPortalChange() {
      if (this.selectedPortalId) {
        this.fecthTopics(this.selectedPortalId);
      }
    },
    getToken() {
      return get_token();
    },
    startRecording() {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };

          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.recordedChunks, { type: 'audio/wav' });
            this.audio_file = audioBlob;
            this.audio_file_name = 'recording.wav';
          };

          this.mediaRecorder.start();
          this.isRecording = true;
        })
        .catch((error) => {
          if (error.name === 'NotAllowedError') {
            Swal.fire({
              icon: 'error',
              title: 'Microphone Access Denied',
              text: 'Please allow microphone access in your browser settings and refresh the page.',
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Error accessing microphone: ${error.message}`
            });
          }
        });
    },

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },
    handleAudioUpload(event) {
      const file = event.target.files[0];
      if (file) {
        if (!file.type.startsWith('audio/')) {
          this.audioError = 'Only audio files are allowed.';
          this.audio_file = null;
          this.audio_file_name = '';
          event.target.value = '';
        } else {
          this.audio_file_name = file.name;
          this.audioError = '';
          this.audio_file = file;
        }
      } else {
        this.audio_file_name = '';
        this.audioError = '';
        this.audio_file = null;
      }
    },
    fetchPortals() {
      this.isLoading = true;
      $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_portals_api/`,
      method: 'POST',
      headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
      },
      data: JSON.stringify(this.payload),

      success: (data) => {
        if(this.user_details.user_role==="admin"){
            this.portals = data.portals;

          }else{
            const portal=data.portals
            this.portals=portal.filter(portal=>portal.has_access=="approved")

          }
      },
      complete: () => {
          this.isLoading = false;
      }
      });
    },
    fetch_users() {
      return new Promise((resolve) => {

        const groupId = this.$route.params.group_id;
      $.ajax({
        type: 'GET',
        data:{group_id:groupId},
        url: process.env.VUE_APP_BACKEND_API_URL + '/system_management/retrieve_users/',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
        this.users = response.data.users_list.filter(user => user.id != this.user_details.user_id);
          resolve();
        },
      });
    });
    },
    fecthTopics(portal_id) {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: {portal_id: portal_id},
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    validationFeedForm() {
      this.errors = {};
      let valid = true;

      if (this.$route.name !== 'view_portal' && this.$route.name !== 'view_topic' && this.$route.name !== 'publish_portal' && !this.selectedPortalId) {
        this.errors.portal = "You must tag a portal.";
        valid = false;
      }

      if (!this.selectedTopicId) {
        this.errors.segment = "You must tag a segment.";
      }
      return valid;
    },
    prepareTemporaryPost() {
      this.temporaryPost = {
        report_name: this.report_name,
        isTemp: true
      };
    },   
    scrollToElementById(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },  
    getQuillContent(quill) {
      let content = quill.root.innerHTML;
      return content.replace(
        /<span class="mention" data-value="([^"]*)"[^>]*>@[^<]*<\/span>/g,
        '@$1'
      );
    },  
    createFormData(content) {
      const formData = new FormData();
    
      if (this.report_url) {
        formData.append('report_link', this.report_url);
      }
    
      if (this.$route.name === 'view_portal' || this.$route.name === 'publish_portal') {
        this.selectedPortalId = this.$route.params.portal_id;
      }
    
      formData.append('portal_id', this.selectedPortalId);
    
      const baseUrl = `${window.location.origin}${this.$route.path}`;
      const encodedReportUrl = encodeURI(`${baseUrl}?report_id=dynamic_placeholder`);
      formData.append('base_url', encodedReportUrl);
    
      if (this.selectedTopicId) {
        formData.append('topic_id', this.selectedTopicId);
      }
    
      formData.append('description', content);
      formData.append('is_public', this.isPublic);
      formData.append('can_comment', this.comments_off);
    
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (this.audio_file) {
        formData.append('file', this.audio_file, this.audio_file_name);
      }

      const tag_ids = Object.values(this.selected_tags).filter(tagId => tagId !== null);
      tag_ids.forEach(id => {
        formData.append('tag_ids', id);
      });
      return formData;
    },  
    handleFormSuccess(response) {
      if (response.status === "success") {
        this.$emit('new_report', response.report_file_data);
        this.$nextTick(() => this.scrollToElementById(`post-${response.report_file_data.id}`));
        this.temporaryPost = null;
        this.resetPortalSelection();
        this.$refs.quillReportEditorRef.quill.root.innerHTML = '';
        this.isDropdownVisible = false;
        $('#feed_modal').modal('hide');

        if(this.$route.name === 'view_topic'){
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Your report has been successfully submitted.',
            showConfirmButton: false,
            timer: 2000
          });
        }
      }
      
    },
    handleFormError(xhr) {
      let message = 'There was an issue with your form submission. Please try again later.';
    
      try {
        const errorResponse = JSON.parse(xhr.responseText);
        if (errorResponse.message) {
          message = errorResponse.message;
        }
      } catch (e) {
        console.error('Non-JSON response:', xhr.responseText);
      }
    
      Swal.fire({
        icon: 'error',
        title: 'Bad Request!',
        text: message,
        confirmButtonText: 'ok',
      });
    }, 
    submit_form() {
      if (!this.validationFeedForm()) return;
      this.$emit('trigger_component')

      this.prepareTemporaryPost();
    
      this.$nextTick(() => this.scrollToElementById('temp-post'));
    
      const quill = this.$refs.quillReportEditorRef?.quill;
      if (!quill) return;
    
      const content = this.getQuillContent(quill);
    
      if (!this.report_url && !this.upload_media && !this.audio_file && content.trim() === "<p><br></p>") {
        this.errors.report_details = "Please fill in at least one of the required fields";
        $('#feed_modal').modal('show');
        this.$emit('remove_temp_post');
        return;
      }
    
      const formData = this.createFormData(content);
    
      this.isSubmitting = true;
      this.$emit('new_temp_post', this.temporaryPost);
      $('#feed_modal').modal('hide');
    
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_report_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: this.handleFormSuccess,
        error: this.handleFormError,
        complete: () => { this.isSubmitting = false; }
      });
    },  
    initQuillEditor() {
      const quill = new Quill('#quillEditor', {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['link', 'video', 'image'],
            ['clean']
          ],
          mention: {
            allowedChars: /^[A-Za-z0-9_]+$/,
            mentionDenotationChars: ['@'],
            source: (searchTerm, renderList) => {
              const matches = this.members
                .filter(member => {
                  const fullName = `${member.full_name}`.toLowerCase();
                  return fullName.includes(searchTerm.toLowerCase());
                })
                .map(member => ({
                  id: member.id,
                  value: `${member.full_name}`
                }));
              renderList(matches);
            },
            renderItem(item) {
              return `${item.value}`;
            }
          }
        },
        placeholder: 'Type your text here...',
      });

      this.$refs.quillReportEditorRef.quill = quill;

      quill.on('text-change', () => {
        const text = quill.root.innerText;
        const lastAtSymbol = text.lastIndexOf('@');

        if (lastAtSymbol !== -1) {
          this.currentTagPosition = lastAtSymbol;
          this.showSuggestions = true;
        } else {
          this.showSuggestions = false;
        }
      });

      quill.on('mention-selected', (user) => {
        this.selectUser(user);
      });
    },
    filterUsers(query) {
      if (!query) {
        this.filteredUsers = this.users;
        return;
      }
      this.filteredUsers = this.users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query.toLowerCase());
      });
    },
    selectUser(user) {

      const quill = this.$refs.quillReportEditorRef.quill;

      const mentionText = `@${user.full_name}`;

      const beforeTag = this.description ? this.description.slice(0, this.currentTagPosition) : '';
    
      // Delete any current text after the "@" trigger

      const cursorPosition = this.currentTagPosition + mentionText.length;
    
      // Clear existing content (optional, adjust as needed)

      quill.deleteText(this.currentTagPosition, quill.getLength());
    
      // Insert the styled mention

      quill.insertText(this.currentTagPosition, mentionText, {

        color: '#0d6efd', // Bootstrap primary blue

        bold: true

      });
    
      // Optionally add a space after mention

      quill.insertText(this.currentTagPosition + mentionText.length, ' ');
    
      // Move cursor after inserted text

      quill.setSelection(this.currentTagPosition + mentionText.length + 1);
    
      // Update your description variable if needed (optional)

      this.description = quill.root.innerHTML;
    
      this.$nextTick(() => {

        this.showSuggestions = false;

      });

    },

    resetForm() {
      this.uploaded_files = [];
      this.fileName = "";

      // Reset file input
      this.$nextTick(() => {
        document.getElementById("fileInput").value = "";
      });
    },
  },
};


